__turbopack_context__.v({
  "dropdown": "select-module__3n__Sq__dropdown",
  "input": "select-module__3n__Sq__input",
});
